import { LoadStatus } from '../load-status';

/**
 * Feature key under which the value-help slice is registered in the root store.
 */
export const VALUE_HELPER_FEATURE_KEY = 'valueHelper';

/**
 * Value-help reference data loaded once from OData (re-loaded on sync). Getters only ever
 * read from `models`, mirroring the backend ValueHelper set. `status` tracks whether the
 * backend data has been loaded (see {@link LoadStatus}).
 */
export type ValueHelperCollectionState = Readonly<{
    valueHelpers: ValueHelperState[];
    status: LoadStatus;
}>;

export const initialValueHelperCollectionState: ValueHelperCollectionState = {
    valueHelpers: [],
    status: LoadStatus.Idle,
};

/**
 * Naked, serializable shape of a value helper — the data fields of {@link ValueHelperModel}
 * without the class. The NgRx value-help slice stores these and the selectors return them;
 * the facade wraps them back into {@link ValueHelperModel} instances via {@link ValueHelperModel.fromState}.
 */
export type ValueHelperState = Readonly<{
    id: string;
    sortField: string;
    code: string;
    codeLevel: string;
    descText: string;
    descTextLong: string;
    werks: string;
    vkorg: string;
    contractCharacteristic?: string;
    contractCharacteristicValue?: string;
}>;
